import * as React from "react";
import { css } from "aphrodite";
import { StarNumRatingStyle } from "main/javascripts/components/molecules/StarRating/StarNumRating/StarNumRatingStyle";
import { StarRating } from "main/javascripts/components/atoms/StarRating";

export interface IProps {
  rating: number;
  styles?: any;
}

export const StarNumRating: React.FC<IProps> = (
  props: IProps
): React.ReactElement | null => {
  const { rating, styles = {}, ...rest } = props;
  const { block, starBlock, num } = styles;
  if (rating === 0) {
    return null;
  }
  return (
    <div className={css(StarNumRatingStyle.block, block)} {...rest}>
      <StarRating
        rating={rating}
        styles={{ block: [StarNumRatingStyle.starBlock, starBlock] }}
      />
      <div className={css(StarNumRatingStyle.num, num)}>{rating}</div>
    </div>
  );
};
